export const contactInfo = {
  email: "weronika.filas@beabeleza.pl",
  instagram:
    "https://www.instagram.com/weronika_filas?igsh=MTcwdXQ4bmphZnZpYQ%253D%253D",
};
